<div class="smart-searcher">
  <vy-cdk-searcher
    (click)="controlClick()"
    [searcherConfiguration]="searcherConfiguration"
    (searcherSubmitted)="redirect($event)"
    (paxInfoClick)="openModalBasedOnPaxType($event)"
    (paxStateChange)="openModalOnUnacompaniedMinorsOrGroups($event)"
    (paxStateError)="openModalOnError($event)"
  ></vy-cdk-searcher>
</div>

<app-promotions [promotionalTexts]="promotionalTexts"></app-promotions>
